import { useEffect, useState } from "react";
import experimentService from "services/experiment/experimentService";

interface IExperimentProps {
  key: string;
  fallback: string | boolean;
}

export const useExperiment = ({ key, fallback }: IExperimentProps) => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [variant, setVariant] = useState<string | boolean>(fallback);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const variant = await experimentService.getVariant(key, fallback);

      setVariant(variant);
      setLoading(false);
    })();
  }, []);

  return {
    isLoading,
    variant
  };
};
